import React from 'react';
import Reflux from 'reflux';
import {Button, Input, Row, Col} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, DisplayForm} from '../../components';
import { openNotice } from 'Utils';

class SecondCusOrderSend extends Reflux.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['创建发货单'],
			selectedRowKeys: [],
			rows: [],
			total: 1,
			searchObj: {
				name: '',
				category: [],
				active: '',
				s: 10,
				p: 1
			}
		};
		this.pageChange = this.pageChange.bind(this);
		this.routeLeaveHook = this.routeLeaveHook.bind(this);
	};

	goBack = () => {
	    hashHistory.goBack();
    }

	/*翻页*/
	pageChange(page, pageSize) {
		let self = this;
		this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
			self.initData();
		});
	}
	/*获取列表数据*/
	initData () {
	}
	//离开当前路由时，更新store
	routeLeaveHook(nextLocation) {
	}

	componentWillMount () {
	}

	componentDidMount () {
		this.initData();
		//设置离开当前路由时的钩子函数
		this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
	}

	render() {
		var self = this;
		const {opts, rows, total, searchObj, selectedRowKeys} = this.state;

		const tableViewProps = {
			loading: false,//更新表格数据中
			rowKey: 'id',
			pageParam: {
				total: total,
				current: searchObj.p,//当前页码
				pageSize: searchObj.s,//当前分页数
				onChange: this.pageChange
			},
			columns: [
				{
					title: '序号',
					dataIndex: 'id'
				}, {
					title: '产品线',
					dataIndex: 'status'
				},
                {
                    title: '品牌',
                    dataIndex: 'type'
                },
                {
                    title: '物料编码',
                    dataIndex: 'date'
                },
                {
                    title: '物料描述',
                    dataIndex: 'customerName'
                },
                {
                    title: '牌价',
                    dataIndex: 'purchaseUnit'
                },
				{
                    title: '下浮价',
                    dataIndex: 'amount'
                },
                {
                    title: '下浮率',
                    dataIndex: 'cash'
                },
                {
                    title: '单位',
                    dataIndex: 'date1'
                },
                {
                    title: '开单数量',
                    dataIndex: 'customerName1'
                },
                {
                    title: '已发数量',
                    dataIndex: 'purchaseUnit1'
                },
				{
                    title: '待发货数量',
                    dataIndex: 'amount1'
                },
                {
                    title: '发货数量',
                    dataIndex: 'cash1',
                    render: () => {
                    	return <Input style={{width:150}}/>
                    }
                }
			],
			rows
		};
		const displayData = [
			{label: '发货单', value: '2016053100001'},
			{label: '订单编号', value: '2016053100001'},
			{label: '客户名称', value: "x'x'x小五金店"},
			{label: '收货人', value: '李军'},
			{label: '联系电话', value: '18999999999'},
			{label: '收货地址', value: '深圳市前海深港合作区前海一路1号A栋201室'}
		];
		const inputLay = {width: 300, marginLeft: 10};
		return (
			<div className="dms-main-box">
				<div>
					<DmsTab options={opts} defaultKey={0}>
						<Button onClick={this.goBack}>返回</Button>
					</DmsTab>
					<div className="dms-table-box">
						<DisplayForm dataSource={displayData} perRow="2"/>
						<div>
				        	<DmsTab className="white-bg no-border" options={['发货清单']} defaultKey={0}/>
				        	<div className="dms-table-box">
				          		<TableView {...tableViewProps}/>
				          		<Row><Col offset={22}><p>发货数量：0</p></Col></Row>
				        	</div>
			       		</div>
			       		<div>
				        	<DmsTab className="white-bg no-border" options={['物流信息']} defaultKey={0}/>
				        	<Row>
				        	    <Col span={12}>物流公司<Input style={inputLay}/></Col>
				        	    <Col span={12}>物流单号<Input style={inputLay}/></Col>
				        	</Row>
			       		</div>
					</div>
				</div>
			</div>
		)
	}
}
;
export default withRouter(SecondCusOrderSend);



// WEBPACK FOOTER //
// ./src/routes/secCusOrder/send.js